export default "__VITE_ASSET__C7B$Xlxn__"